jQuery(document).ready(function(){
function carouselImages(){
	jQuery('.jsMobile').each(function() {
		var inifnite  = jQuery(this).data('infinite') === true ? true : false;
		var autoplay  = jQuery(this).data('autoplay') === true ? true : false;
		console.log(autoplay)
		jQuery(this).flickity({
			freeScroll: true,
			wrapAround: inifnite,
			autoPlay: autoplay,
			adaptiveHeight: true,
			setGallerySize: true
		})
	});
	
}

function setHeights(){
	jQuery('.product-carousel').each(function(el) {
		var ratio = $(this).find('.jsCarHeight').data('ratio');
		// console.log(ratio);

		var blockWidth = $(this).find('.jsCarHeight').width();
		// console.log(blockWidth)
		console.log(blockWidth / ratio)
		jQuery(this).css('height', blockWidth / ratio);
		console.log($(this))
	});
}

  setHeights();
carouselImages();
console.log('test');



$(document).on('shopify:section:unload', function(event) {
carouselImages()
});

$(document).on('shopify:section:load', function(event) {
carouselImages()
});

  })